import { API_POPIN_PREFIX } from '../constants';

const urlEventCSVReport = API_POPIN_PREFIX + '/events/:id/report?type=csv';

export const csvApi = {
  csvDownloadUri: (eventId) => {
    if (!eventId) {
      throw new Error('csvReport requires an eventId');
    }
    return urlEventCSVReport.replace(':id', eventId);
  }
};
